var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    viewBox: "0 0 58 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5312 60.4551L29.0683 60.6049L29.6054 60.4553L49.101 55.0239L50.434 54.6526L50.5564 53.2743L54.8935 4.44797L55.0869 2.27101H52.9014H5.29419H3.10889L3.30201 4.44776L7.63464 53.2815L7.7569 54.6595L9.08938 55.0312L28.5312 60.4551Z",
    fill: "#264DE4",
    stroke: "#001E36",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8511 49.9882L48.5572 8.26379H29.0977V54.377L44.8511 49.9882Z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2265 26.3756L15.7606 32.3648H29.0977V26.3756H15.2265ZM14.1531 14.2532L14.6948 20.2425H29.0977V14.2532H14.1531ZM29.0977 41.9304L29.0716 41.9373L22.4341 40.1362L22.0097 35.3596H16.0269L16.8618 44.7636L29.0703 48.1692L29.0977 48.1618V41.9304Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.931 26.3756L44.0069 14.2532H29.0773V20.2425H37.4754L36.9331 26.3756H29.0773V32.3648H36.4163L35.7244 40.1325L29.0771 41.9354V48.1664L41.2954 44.7636L41.3849 43.7517L42.7857 27.9839L42.931 26.3756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.4ce6b59275515cac57cf995c3aed694b.svg";
export { ForwardRef as ReactComponent };